export class Enums {
  static role = {
    superAdmin: 100,
    dataentry_qa: 10,
    audit_qa: 11,
    admin_qa: 12,
    manager_qa: 13,
    admin: 1,
    dataEntry: 2,
    audit: 3,
    generalManager: 4,
    stock: 5,
    manager: 6,
  };

  static actionType = {
    mech: {
      value: 1,
      name: "ميكانيكا",
    },
    elec_control: {
      value: 2,
      name: "كهرباء وكنترول",
    },
  };

  static troubhleShootingType = {
    comp: {
      value: 1,
      name: "كمبيوتر",
    },
    mech_elec: {
      value: 2,
      name: "ميكانيكا وكهرباء",
    },
    mech: {
      value: 3,
      name: "ميكانيكا",
    },
    elec: {
      value: 4,
      name: "كهرباء",
    },
  };

  static roleName = {
    1: "admin",
    2: "dataEntry",
    3: "audit",
    4: "manager",
    5: "stock",
    10: "dataentry_qa",
    11: "audit_qa",
    12: "manager_qa",
    100: "superadmin",
  };

  static qaVisitStatus = {
    0: "",
    1: "مقبول",
    2: "غير مقبول",
    3: "خطر",
  };
}
